<template>
    <ResumeImportUploadFile
        class="edit-resume-import-step-upload-file"
        :rule-dropzone-file-formats="ruleDropzoneFileFormats"
        :rule-dropzone-max-file-size="ruleDropzoneMaxFileSize"
        @update:model-value="(file) => (uploadedResumeFile = file)"
    />
</template>
<script setup lang="ts">
    import {onMounted, ref, watch} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useDataTracking} from '#imports';
    import ResumeImportUploadFile from '~/components/resume-import/ResumeImportUploadFile.vue';
    import type {EditionOpenedEntryPoint} from '~/config/TrackingEvents';
    import {ResumeImportStep, TrackingEvents} from '~/config/TrackingEvents';
    import {useDefineFunnelNextStepHandler} from '~/features/resume-import/composable/useDefineFunnelNextStepHandler';
    import {resumeImportUploadRules} from '~/features/resume-import/config/ResumeImportRules';
    import {useResumeImportStore} from '~/features/resume-import/store/useResumeImportStore';

    const resumeImportStore = useResumeImportStore();
    const {resumeFileUpload} = resumeImportStore;
    const {isFunnelCtaNextEnabled} = storeToRefs(resumeImportStore);

    const isStepLoading = ref<boolean>(false);
    const uploadedResumeFile = ref<File | undefined>();

    const ruleDropzoneFileFormats = resumeImportUploadRules.fileFormats;
    const ruleDropzoneMaxFileSize = resumeImportUploadRules.maxFileSize;

    const emit = defineEmits<{
        (e: 'entry-point:reset'): void;
    }>();

    const props = defineProps<{
        entryPoint: EditionOpenedEntryPoint;
    }>();

    // Composable
    useDefineFunnelNextStepHandler(stepNextAction);
    const {track} = useDataTracking();

    onMounted(() => {
        clear();
        track(TrackingEvents.RESUME_IMPORT_FUNNEL, {funnel_step: ResumeImportStep.UPLOAD_RESUME, entry_point: props.entryPoint});
        emit('entry-point:reset');
    });

    watch(uploadedResumeFile, () => {
        isFunnelCtaNextEnabled.value = !!uploadedResumeFile.value;
    });

    async function stepNextAction(): Promise<void> {
        try {
            isStepLoading.value = true;
            if (uploadedResumeFile.value) {
                await resumeFileUpload(uploadedResumeFile.value);
                clear();
            }
        } finally {
            isStepLoading.value = false;
        }
    }
    function clear(): void {
        isFunnelCtaNextEnabled.value = false;
    }
</script>
